"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var InfoIcon = (0, react_1.forwardRef)(function (props, ref) { return (react_1.default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "12", height: "13", viewBox: "0 0 12 13", fill: "none", ref: ref }, props),
    react_1.default.createElement("g", { clipPath: "url(#clip0_14248_56044)" },
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 11.7502C8.76142 11.7502 11 9.51161 11 6.75018C11 3.98876 8.76142 1.75018 6 1.75018C3.23858 1.75018 1 3.98876 1 6.75018C1 9.51161 3.23858 11.7502 6 11.7502ZM6 12.7502C9.31371 12.7502 12 10.0639 12 6.75018C12 3.43647 9.31371 0.750183 6 0.750183C2.68629 0.750183 0 3.43647 0 6.75018C0 10.0639 2.68629 12.7502 6 12.7502ZM5.25 4.50473C5.25 4.91382 5.58636 5.25018 5.99545 5.25018C6.40455 5.25018 6.75 4.91382 6.75 4.50473C6.75 4.09564 6.40455 3.75018 5.99545 3.75018C5.58636 3.75018 5.25 4.09564 5.25 4.50473ZM6 6.00018C5.58579 6.00018 5.25 6.33597 5.25 6.75018V9.00018C5.25 9.4144 5.58579 9.75018 6 9.75018C6.41421 9.75018 6.75 9.4144 6.75 9.00018V6.75018C6.75 6.33597 6.41421 6.00018 6 6.00018Z", fill: "#6D7184" })),
    react_1.default.createElement("defs", null,
        react_1.default.createElement("clipPath", { id: "clip0_14248_56044" },
            react_1.default.createElement("rect", { width: "12", height: "12", fill: "white", transform: "translate(0 0.750183)" }))))); });
exports.default = InfoIcon;
//# sourceMappingURL=InfoIcon.js.map